import moment from "moment";
import {mapGetters} from "vuex";

export default {
    computed: {
        ...mapGetters(['profile']),
    },

    methods: {
        getImageUrl(url) {
            try {
                return require('@/assets' + url);
            } catch (e) {
                return require('@/assets/images/no-image.png');
            }
        },

        checkProductImageURL(product) {
            if (product.images.length > 0) {
                return product.images[0].url
            }
            return false;
        },

        transformDate(date) {
            return moment(date).format('MMM.Do, YYYY');
        },

        transformMembershipDate(date) {
            return moment(date).format('MM/DD/YY');
        },

        getCurrentDate() {
            return moment().format('h:mm A dddd, MMM. D, YYYY');
        },

        transformDateCustom(date, format) {
            return moment(date).format(format);
        },

        getCurlDense() {
            return this.isNotSure(this.profile['curl_dense'], 'gently_part_hair');
        },

        getCategorizeSingleStrand() {
            return this.isNotSure(this.profile['categorize_single_strand'], 'grab_strand_hair');
        },

        getPorosityWork() {
            return this.isNotSure(this.profile['porosity_work'], 'dry_hair_time');
        },

        getActiveAverage() {
            return this.profile['active_average'];
        },

         getTopCurlGoal() {
            return this.profile['top_curl_goal'];
        },

        getCurlSitSpectrum() {
            return this.profile['curl_sit_spectrum'];
        },

        getCurlsLength() {
            return this.profile['curls_length'];
        },

        getTimeToCurls() {
            return this.profile['time_to_curls'];
        },

        isReadyProfile() {
            return this.profile;
        },

        isNotSure(value, correctNameValue) {
            return (value === 'Not Sure') ? this.profile[correctNameValue] : value;
        },

        showModal(modalType, data = null) {
            if(modalType) {
                this.$store.commit('SHOW_MODAL', {modalType, data});
            } else {
                this.$store.commit('HIDE_MODAL');
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/profileMixin.js